<template>
  <v-container>
    <v-card :loading="false">
      <v-overlay :absolute="true" :value="isComponentLoading">
        <v-progress-circular indeterminate size="24"></v-progress-circular>
      </v-overlay>
      <v-row class="pa-3">
        <v-col cols="12" md="6">
          <v-text-field
            v-model="searchText"
            :hint="lang($store, 'sap/listings.global.filter.hints.search_name_contact')"
            persistent-hint
            single-line
            :loading="false"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="searchTextCleaner"
            :hint="lang($store, 'sap/listings.global.filter.hints.search_name_cleaner')"
            persistent-hint
            single-line
            :loading="false"
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-menu
            v-model="menuFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="fromDateFormatted"
                @input="changeDate('from', $event)"
                :label="lang($store, 'sap/listings.global.filter.hints.date_from')"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchParams.from"
              no-title
              :first-day-of-week="1"
              :locale="getCurrentLocale()"
              @input="menuFrom = false"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" md="3">
          <v-menu
            v-model="menuTo"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="toDateFormatted"
                @input="changeDate('to', $event)"
                :label="lang($store, 'sap/listings.global.filter.hints.date_to')"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchParams.to"
              no-title
              :first-day-of-week="1"
              :locale="getCurrentLocale()"
              @input="menuTo = false"
            ></v-date-picker>
          </v-menu>
        </v-col>


        <v-col v-if="$store.getters.appType === 'uberem'" cols="12" md="3">
          <v-menu
            ref="menuTime"
            v-model="menuTimeFrom"
            :close-on-content-click="false"
            :return-value.sync="fromTimeFormatted"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="searchParams.time_from"
                :value="fromTimeFormatted"
                :label="lang($store, 'sap/listings.global.filter.hints.time_from')"
                @click="searchParams.time_from=null"
                prepend-icon="mdi-clock"
                readonly
                clearable
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              format="24hr"
              v-if="menuTimeFrom"
              v-model="searchParams.time_from"
              @input="menuTimeFrom = false;"
              full-width
              @click:minute="$refs.menu.save(searchParams.time_from)"
            ></v-time-picker>
          </v-menu>
        </v-col>

        <v-col v-if="$store.getters.appType === 'uberem'" cols="12" md="3">
          <v-menu
            ref="menuTime"
            v-model="menuTimeTo"
            :close-on-content-click="false"
            :return-value.sync="fromTimeFormatted"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="searchParams.time_to"
                :value="toTimeFormatted"
                :label="lang($store, 'sap/listings.global.filter.hints.time_to')"
                @click="searchParams.time_to=null"
                prepend-icon="mdi-clock"
                readonly
                clearable
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              format="24hr"
              v-if="menuTimeTo"
              v-model="searchParams.time_to"
              @input="menuTimeTo = false;"
              full-width
              @click:minute="$refs.menu.save(searchParams.time_to)"
            ></v-time-picker>
          </v-menu>
        </v-col>


        <v-col cols="12" md="4">
          <v-select
            multiple
            v-model="searchParams.trackers"
            :items="trackerItems"
            single-line
            :hint="lang($store, 'sap/listings.global.filter.hints.tracker')"
            persistent-hint
          ></v-select>
        </v-col>

        <v-col cols="12" md="2">
          <v-select
            v-model="searchParams.is_cleaner_ok"
            :hint="lang($store, 'sap/listings.global.filter.hints.cleaner_ok')"
            :items="cleanersOkItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>

        <v-col cols="12" md="2">
          <v-select
            v-model="searchParams.is_contact_ok"
            :hint="lang($store, 'sap/listings.global.filter.hints.client_ok')"
            :items="cleanersOkItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>

        <v-col cols="12" md="2">
          <v-select
            multiple
            v-model="searchParams.statuses"
            :items="orderStatusItems"
            prepend-icon="mdi-cart-arrow-right"
            single-line
            :hint="lang($store, 'sap/listings.global.filter.hints.order_status')"
            persistent-hint
          ></v-select>
        </v-col>

        <v-col cols="12" md="2">
          <v-select
            v-model="searchParams.is_presence"
            :hint="lang($store, 'sap/listings.global.filter.hints.cleaner_on_site')"
            prepend-icon="mdi-account"
            :items="cleanersOkItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>

        <v-col cols="12" md="9">
          <v-select
            multiple
            v-model="searchParams.types"
            :items="orderComplexTypeItems"
            prepend-icon="mdi-format-list-bulleted-type"
            single-line
            :hint="lang($store, 'sap/listings.global.filter.hints.type')"
            persistent-hint
          ></v-select>
        </v-col>
        <v-col cols="12">
          <v-select
            multiple
            v-model="sources"
            :items="sourcesItems"
            prepend-icon="mdi-arrow-decision-outline"
            single-line
            :hint="lang($store, 'sap/listings.global.filter.hints.source')"
            persistent-hint
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            v-model="searchParams.region"
            :hint="lang($store, 'sap/listings.global.filter.hints.region')"
            :items="regionsItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="searchParams.cleaner_region"
            :hint="lang($store, 'sap/listings.global.filter.hints.cleaner_region')"
            :items="cleanerRegionsItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>
        <v-col class="d-flex align-center" cols="12" md="4">
          <v-select
            v-model="searchParams.order_by"
            :hint="lang($store, 'sap/listings.global.filter.hints.sort_by')"
            :items="orderByItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
          <order-to v-model="searchParams.order_to" :small="false" class="ml-2"></order-to>
        </v-col>
      </v-row>
      <download-file-button
        v-if="canDownloadFileReport"
        :use-download-report-users="true"
        style="position: absolute; top: 5px; right: 35px"
        @click="$emit('download-excel')"
      />
      <send-file-button
        v-if="canSendFileReport"
        style="position: absolute; top: 6px; right: 5px"
        @click="$emit('send-email-excel')"
      />
    </v-card>
  </v-container>
</template>

<script>
import moment from 'moment';
/* constants */
import { DATE_ISO } from '@/constants/dates';
import { MANAGER_TOP } from '@/constants/roles';
import { MAIN_SOURCES as ORDER_SOURCES } from '~constants/sources';
import * as orderStatuses from '@/constants/order_statuses';
import * as orderTypes from '~constants/order_complex_types';
import * as trackers from '@/constants/trackers';
/* mixins */
import isComponentLoading from '@/mixins/isComponentLoading';
import regionsFilter from '@/mixins/filters/regionsFilter';
import payedFilter from '@/mixins/filters/payedFilter';
import searchTextFilter from '@/mixins/filters/searchTextFilter';
import searchCleanerFilter from '@/mixins/filters/searchCleanerFilter';
import orderStatusFilter from '@/mixins/filters/orderStatusFilter';
import orderTypeFilter from '@/mixins/filters/orderComplexTypeFilter';
import trackerFilter from '@/mixins/filters/trackerFilter';
import cleanersOkItems from '@/mixins/filters/cleanersOkFilter';
import orderSourceFilter from '@/mixins/filters/sourcesFilter';
/* components */
import DownloadFileButton from '@/components/minialerts/DownloadFileButton.vue';
import OrderTo from '@/components/minialerts/OrderTo.vue';
import SendFileButton from '@/components/minialerts/SendEmailFileButton.vue';
import i18n from '@/i18n';
import regionsCleanersFilter from '@/mixins/filters/regionsCleanersFilter';

/* TODO:add mixin */
export default {
  name: 'FilterOrdersComplex',
  mixins: [
    isComponentLoading,
    regionsFilter,
    regionsCleanersFilter,
    cleanersOkItems,
    payedFilter,
    searchTextFilter,
    searchCleanerFilter,
    orderStatusFilter,
    orderTypeFilter,
    trackerFilter,
    orderSourceFilter,
  ],
  components: {
    DownloadFileButton,
    OrderTo,
    SendFileButton,
  },
  props: {
    defaultSearchParams: {
      type: Object,
      default: () => ({
        is_cleaner_ok: null,
        is_contact_ok: null,
        search_contact: '',
        search_cleaner: '',
      }),
    },
  },
  data() {
    return {
      MANAGER_TOP,
      useNullableOrderStatus: false,
      useNullableOrderComplexType: false,
      useNullableTracker: false,
      useNullableSource: false,
      searchParams: {},
      menuFrom: false,
      menuTo: false,
      sources: [],
      timeFrom: null,
      timeTo: null,
      menuTimeFrom: false,
      menuTimeTo: false,
    };
  },
  mounted() {
    this.searchParams = {
      order_by: this.defaultSearchParams.order_by || 'datetime',
      order_to: this.defaultSearchParams.order_to || 'asc',
      search_contact: this.defaultSearchParams.search_contact,
      search_cleaner: this.defaultSearchParams.search_cleaner,
      from: moment()
        // .subtract(7, 'days')
        .startOf('day')
        .format(DATE_ISO),
      to: null,
      time_from: null,
      time_to: null,
      trackers: [trackers.REMAKE, trackers.ESTIMATE, trackers.ORDER, trackers.CONTINUE],
      statuses: [orderStatuses.ORDERED],
      types: [ ],
      is_payed: null,
      region: null,
      cleaner_region: null,
      is_presence: null,
      is_cleaner_ok: null,
      is_contact_ok: null,
      with_address: true,
      sources: JSON.parse(JSON.stringify(this.initSources())),
    };

    Object.keys(orderTypes)
      .forEach((key) => {
        if (key !== 'COMPLEX_TYPES') {
          this.searchParams.types.push(orderTypes[key]);
        }
      });
  },
  computed: {
    orderByItems() {
      return [
        {
          text: i18n.t('hints.sortByDate'),
          value: 'datetime',
        },
      ];
    },
    account() {
      return this.$store.getters['account/account'];
    },
    fromDateFormatted() {
      return this.formatDate(this.searchParams.from);
    },
    toDateFormatted() {
      return this.formatDate(this.searchParams.to);
    },
    fromTimeFormatted() {
      return this.formatTime(this.searchParams.time_from);
    },
    toTimeFormatted() {
      return this.formatTime(this.searchParams.time_to);
    },
    canDownloadFileReport() {
      return true;
    },
    canSendFileReport() {
      return true;
    },
  },
  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('filtering', newVal);
      },
      deep: true,
    },
    sources: {
      handler(newVal, oldVal) {
        this.searchParams.sources.splice(0);
        if (newVal.length) {
          const values = [];
          newVal.forEach(($item) => {
            values.push($item);
          });
          this.searchParams.sources = JSON.parse(JSON.stringify(values));
        } else {
          this.searchParams.sources = JSON.parse(JSON.stringify(this.initSources()));
        }
      },
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    formatTime(date) {
      if (!date) return null;
      const [hour, minute] = date.split(':');
      return `${hour}:${minute}`;
    },
    changeDate(type, date) {
      if (date === null) {
        this.searchParams[type] = null;
      }
    },
    initSources() {
      const values = [];
      ORDER_SOURCES.forEach(($item) => values.push($item));
      return values;
    },
    getCurrentLocale() {
      return window.localStorage.language;
    }
  },
};
</script>

<style scoped>
</style>
